import React from 'react';
import { Line } from 'react-chartjs-2';

const data = {
  labels: ['6/1/21 0:00',
    '6/1/21 1:00',
    '6/1/21 2:00',
    '6/1/21 3:00',
    '6/1/21 4:00',
    '6/1/21 5:00',
    '6/1/21 6:00',
    '6/1/21 7:00',
    '6/1/21 8:00',
    '6/1/21 9:00',
    '6/1/21 10:00',
    '6/1/21 11:00',
    '6/1/21 12:00',
    '6/1/21 13:00',
    '6/1/21 14:00',
    '6/1/21 15:00',
    '6/1/21 16:00',
    '6/1/21 17:00',
    '6/1/21 18:00',
    '6/1/21 19:00',
    '6/1/21 20:00',
    '6/1/21 21:00',
    '6/1/21 22:00',
    '6/1/21 23:00',
    '6/2/21 0:00',
    '6/2/21 1:00',
    '6/2/21 2:00',
    '6/2/21 3:00',
    '6/2/21 4:00',
    '6/2/21 5:00',
    '6/2/21 6:00',
    '6/2/21 7:00',
    '6/2/21 8:00',
    '6/2/21 9:00',
    '6/2/21 10:00',
    '6/2/21 11:00',
    '6/2/21 12:00',
    '6/2/21 13:00',
    '6/2/21 14:00',
    '6/2/21 15:00',
    '6/2/21 16:00',
    '6/2/21 17:00',
    '6/2/21 18:00',
    '6/2/21 19:00',
    '6/2/21 20:00',
    '6/2/21 21:00',
    '6/2/21 22:00',
    '6/2/21 23:00',
    '6/3/21 0:00',
    '6/3/21 1:00',
    '6/3/21 2:00',
    '6/3/21 3:00',
    '6/3/21 4:00',
    '6/3/21 5:00',
    '6/3/21 6:00',
    '6/3/21 7:00',
    '6/3/21 8:00',
    '6/3/21 9:00',
    '6/3/21 10:00',
    '6/3/21 11:00',
    '6/3/21 12:00',
    '6/3/21 13:00',
    '6/3/21 14:00',
    '6/3/21 15:00',
    '6/3/21 16:00',
    '6/3/21 17:00',
    '6/3/21 18:00',
    '6/3/21 19:00',
    '6/3/21 20:00',
    '6/3/21 21:00',
    '6/3/21 22:00',
    '6/3/21 23:00',
    '6/4/21 0:00',
    '6/4/21 1:00',
    '6/4/21 2:00',
    '6/4/21 3:00',
    '6/4/21 4:00',
    '6/4/21 5:00',
    '6/4/21 6:00',
    '6/4/21 7:00',
    '6/4/21 8:00',
    '6/4/21 9:00',
    '6/4/21 10:00',
    '6/4/21 11:00',
    '6/4/21 12:00',
    '6/4/21 13:00',
    '6/4/21 14:00',
    '6/4/21 15:00',
    '6/4/21 16:00',
    '6/4/21 17:00',
    '6/4/21 18:00',
    '6/4/21 19:00',
    '6/4/21 20:00',
    '6/4/21 21:00',
    '6/4/21 22:00',
    '6/4/21 23:00',
    '6/5/21 0:00',
    '6/5/21 1:00',
    '6/5/21 2:00',
    '6/5/21 3:00',
    '6/5/21 4:00',
    '6/5/21 5:00',
    '6/5/21 6:00',
    '6/5/21 7:00',
    '6/5/21 8:00',
    '6/5/21 9:00',
    '6/5/21 10:00',
    '6/5/21 11:00',
    '6/5/21 12:00',
    '6/5/21 13:00',
    '6/5/21 14:00',
    '6/5/21 15:00',
    '6/5/21 16:00',
    '6/5/21 17:00',
    '6/5/21 18:00',
    '6/5/21 19:00',
    '6/5/21 20:00',
    '6/5/21 21:00',
    '6/5/21 22:00',
    '6/5/21 23:00',
    '6/6/21 0:00',
    '6/6/21 1:00',
    '6/6/21 2:00',
    '6/6/21 3:00',
    '6/6/21 4:00',
    '6/6/21 5:00',
    '6/6/21 6:00',
    '6/6/21 7:00',
    '6/6/21 8:00',
    '6/6/21 9:00',
    '6/6/21 10:00',
    '6/6/21 11:00',
    '6/6/21 12:00',
    '6/6/21 13:00',
    '6/6/21 14:00',
    '6/6/21 15:00',
    '6/6/21 16:00',
    '6/6/21 17:00',
    '6/6/21 18:00',
    '6/6/21 19:00',
    '6/6/21 20:00',
    '6/6/21 21:00',
    '6/6/21 22:00',
    '6/6/21 23:00',
    '6/7/21 0:00',
    '6/7/21 1:00',
    '6/7/21 2:00',
    '6/7/21 3:00',
    '6/7/21 4:00',
    '6/7/21 5:00',
    '6/7/21 6:00',
    '6/7/21 7:00',
    '6/7/21 8:00',
    '6/7/21 9:00',
    '6/7/21 10:00',
    '6/7/21 11:00',
    '6/7/21 12:00',
    '6/7/21 13:00',
    '6/7/21 14:00',
    '6/7/21 15:00',
    '6/7/21 16:00',
    '6/7/21 17:00',
    '6/7/21 18:00',
    '6/7/21 19:00',
    '6/7/21 20:00',
    '6/7/21 21:00',
    '6/7/21 22:00',
    '6/7/21 23:00',
    '6/8/21 0:00',
    '6/8/21 1:00',
    '6/8/21 2:00',
    '6/8/21 3:00',
    '6/8/21 4:00',
    '6/8/21 5:00',
    '6/8/21 6:00',
    '6/8/21 7:00',
    '6/8/21 8:00',
    '6/8/21 9:00',
    '6/8/21 10:00',
    '6/8/21 11:00',
    '6/8/21 12:00',
    '6/8/21 13:00',
    '6/8/21 14:00',
    '6/8/21 15:00',
    '6/8/21 16:00',
    '6/8/21 17:00',
    '6/8/21 18:00',
    '6/8/21 19:00',
    '6/8/21 20:00',
    '6/8/21 21:00',
    '6/8/21 22:00',
    '6/8/21 23:00',
    '6/9/21 0:00',
    '6/9/21 1:00',
    '6/9/21 2:00',
    '6/9/21 3:00',
    '6/9/21 4:00',
    '6/9/21 5:00',
    '6/9/21 6:00',
    '6/9/21 7:00',
    '6/9/21 8:00',
    '6/9/21 9:00',
    '6/9/21 10:00',
    '6/9/21 11:00',
    '6/9/21 12:00',
    '6/9/21 13:00',
    '6/9/21 14:00',
    '6/9/21 15:00',
    '6/9/21 16:00',
    '6/9/21 17:00',
    '6/9/21 18:00',
    '6/9/21 19:00',
    '6/9/21 20:00',
    '6/9/21 21:00',
    '6/9/21 22:00',
    '6/9/21 23:00',
    '6/10/21 0:00',
    '6/10/21 1:00',
    '6/10/21 2:00',
    '6/10/21 3:00',
    '6/10/21 4:00',
    '6/10/21 5:00',
    '6/10/21 6:00',
    '6/10/21 7:00',
    '6/10/21 8:00',
    '6/10/21 9:00',
    '6/10/21 10:00',
    '6/10/21 11:00',
    '6/10/21 12:00',
    '6/10/21 13:00',
    '6/10/21 14:00',
    '6/10/21 15:00',
    '6/10/21 16:00',
    '6/10/21 17:00',
    '6/10/21 18:00',
    '6/10/21 19:00',
    '6/10/21 20:00',
    '6/10/21 21:00',
    '6/10/21 22:00',
    '6/10/21 23:00',
    '6/11/21 0:00',
    '6/11/21 1:00',
    '6/11/21 2:00',
    '6/11/21 3:00',
    '6/11/21 4:00',
    '6/11/21 5:00',
    '6/11/21 6:00',
    '6/11/21 7:00',
    '6/11/21 8:00',
    '6/11/21 9:00',
    '6/11/21 10:00',
    '6/11/21 11:00',
    '6/11/21 12:00',
    '6/11/21 13:00',
    '6/11/21 14:00',
    '6/11/21 15:00',
    '6/11/21 16:00',
    '6/11/21 17:00',
    '6/11/21 18:00',
    '6/11/21 19:00',
    '6/11/21 20:00',
    '6/11/21 21:00',
    '6/11/21 22:00',
    '6/11/21 23:00',
    '6/12/21 0:00',
    '6/12/21 1:00',
    '6/12/21 2:00',
    '6/12/21 3:00',
    '6/12/21 4:00',
    '6/12/21 5:00',
    '6/12/21 6:00',
    '6/12/21 7:00',
    '6/12/21 8:00',
    '6/12/21 9:00',
    '6/12/21 10:00',
    '6/12/21 11:00',
    '6/12/21 12:00',
    '6/12/21 13:00',
    '6/12/21 14:00',
    '6/12/21 15:00',
    '6/12/21 16:00',
    '6/12/21 17:00',
    '6/12/21 18:00',
    '6/12/21 19:00',
    '6/12/21 20:00',
    '6/12/21 21:00',
    '6/12/21 22:00',
    '6/12/21 23:00',
    '6/13/21 0:00',
    '6/13/21 1:00',
    '6/13/21 2:00',
    '6/13/21 3:00',
    '6/13/21 4:00',
    '6/13/21 5:00',
    '6/13/21 6:00',
    '6/13/21 7:00',
    '6/13/21 8:00',
    '6/13/21 9:00',
    '6/13/21 10:00',
    '6/13/21 11:00',
    '6/13/21 12:00',
    '6/13/21 13:00',
    '6/13/21 14:00',
    '6/13/21 15:00',
    '6/13/21 16:00',
    '6/13/21 17:00',
    '6/13/21 18:00',
    '6/13/21 19:00',
    '6/13/21 20:00',
    '6/13/21 21:00',
    '6/13/21 22:00',
    '6/13/21 23:00',
    '6/14/21 0:00',
    '6/14/21 1:00',
    '6/14/21 2:00',
    '6/14/21 3:00',
    '6/14/21 4:00',
    '6/14/21 5:00',
    '6/14/21 6:00',
    '6/14/21 7:00',
    '6/14/21 8:00',
    '6/14/21 9:00',
    '6/14/21 10:00',
    '6/14/21 11:00',
    '6/14/21 12:00',
    '6/14/21 13:00',
    '6/14/21 14:00',
    '6/14/21 15:00',
    '6/14/21 16:00',
    '6/14/21 17:00',
    '6/14/21 18:00',
    '6/14/21 19:00',
    '6/14/21 20:00',
    '6/14/21 21:00',
    '6/14/21 22:00',
    '6/14/21 23:00',
    '6/15/21 0:00',
    '6/15/21 1:00',
    '6/15/21 2:00',
    '6/15/21 3:00',
    '6/15/21 4:00',
    '6/15/21 5:00',
    '6/15/21 6:00',
    '6/15/21 7:00',
    '6/15/21 8:00',
    '6/15/21 9:00',
    '6/15/21 10:00',
    '6/15/21 11:00',
    '6/15/21 12:00',
    '6/15/21 13:00',
    '6/15/21 14:00',
    '6/15/21 15:00',
    '6/15/21 16:00',
    '6/15/21 17:00',
    '6/15/21 18:00',
    '6/15/21 19:00',
    '6/15/21 20:00',
    '6/15/21 21:00',
    '6/15/21 22:00',
    '6/15/21 23:00',
    '6/16/21 0:00',
    '6/16/21 1:00',
    '6/16/21 2:00',
    '6/16/21 3:00',
    '6/16/21 4:00',
    '6/16/21 5:00',
    '6/16/21 6:00',
    '6/16/21 7:00',
    '6/16/21 8:00',
    '6/16/21 9:00',
    '6/16/21 10:00',
    '6/16/21 11:00',
    '6/16/21 12:00',
    '6/16/21 13:00',
    '6/16/21 14:00',
    '6/16/21 15:00',
    '6/16/21 16:00',
    '6/16/21 17:00',
    '6/16/21 18:00',
    '6/16/21 19:00',
    '6/16/21 20:00',
    '6/16/21 21:00',
    '6/16/21 22:00',
    '6/16/21 23:00',
    '6/17/21 0:00',
    '6/17/21 1:00',
    '6/17/21 2:00',
    '6/17/21 3:00',
    '6/17/21 4:00',
    '6/17/21 5:00',
    '6/17/21 6:00',
    '6/17/21 7:00',
    '6/17/21 8:00',
    '6/17/21 9:00',
    '6/17/21 10:00',
    '6/17/21 11:00',
    '6/17/21 12:00',
    '6/17/21 13:00',
    '6/17/21 14:00',
    '6/17/21 15:00',
    '6/17/21 16:00',
    '6/17/21 17:00',
    '6/17/21 18:00',
    '6/17/21 19:00',
    '6/17/21 20:00',
    '6/17/21 21:00',
    '6/17/21 22:00',
    '6/17/21 23:00',
    '6/18/21 0:00',
    '6/18/21 1:00',
    '6/18/21 2:00',
    '6/18/21 3:00',
    '6/18/21 4:00',
    '6/18/21 5:00',
    '6/18/21 6:00',
    '6/18/21 7:00',
    '6/18/21 8:00',
    '6/18/21 9:00',
    '6/18/21 10:00',
    '6/18/21 11:00',
    '6/18/21 12:00',
    '6/18/21 13:00',
    '6/18/21 14:00',
    '6/18/21 15:00',
    '6/18/21 16:00',
    '6/18/21 17:00',
    '6/18/21 18:00',
    '6/18/21 19:00',
    '6/18/21 20:00',
    '6/18/21 21:00',
    '6/18/21 22:00',
    '6/18/21 23:00',
    '6/19/21 0:00',
    '6/19/21 1:00',
    '6/19/21 2:00',
    '6/19/21 3:00',
    '6/19/21 4:00',
    '6/19/21 5:00',
    '6/19/21 6:00',
    '6/19/21 7:00',
    '6/19/21 8:00',
    '6/19/21 9:00',
    '6/19/21 10:00',
    '6/19/21 11:00',
    '6/19/21 12:00',
    '6/19/21 13:00',
    '6/19/21 14:00',
    '6/19/21 15:00',
    '6/19/21 16:00',
    '6/19/21 17:00',
    '6/19/21 18:00',
    '6/19/21 19:00',
    '6/19/21 20:00',
    '6/19/21 21:00',
    '6/19/21 22:00',
    '6/19/21 23:00',
    '6/20/21 0:00',
    '6/20/21 1:00',
    '6/20/21 2:00',
    '6/20/21 3:00',
    '6/20/21 4:00',
    '6/20/21 5:00',
    '6/20/21 6:00',
    '6/20/21 7:00',
    '6/20/21 8:00',
    '6/20/21 9:00',
    '6/20/21 10:00',
    '6/20/21 11:00',
    '6/20/21 12:00',
    '6/20/21 13:00',
    '6/20/21 14:00',
    '6/20/21 15:00',
    '6/20/21 16:00',
    '6/20/21 17:00',
    '6/20/21 18:00',
    '6/20/21 19:00',
    '6/20/21 20:00',
    '6/20/21 21:00',
    '6/20/21 22:00',
    '6/20/21 23:00',
    '6/21/21 0:00',
    '6/21/21 1:00',
    '6/21/21 2:00',
    '6/21/21 3:00',
    '6/21/21 4:00',
    '6/21/21 5:00',
    '6/21/21 6:00',
    '6/21/21 7:00',
    '6/21/21 8:00',
    '6/21/21 9:00',
    '6/21/21 10:00',
    '6/21/21 11:00',
    '6/21/21 12:00',
    '6/21/21 13:00',
    '6/21/21 14:00',
    '6/21/21 15:00',
    '6/21/21 16:00',
    '6/21/21 17:00',
    '6/21/21 18:00',
    '6/21/21 19:00',
    '6/21/21 20:00',
    '6/21/21 21:00',
    '6/21/21 22:00',
    '6/21/21 23:00',
    '6/22/21 0:00',
    '6/22/21 1:00',
    '6/22/21 2:00',
    '6/22/21 3:00',
    '6/22/21 4:00',
    '6/22/21 5:00',
    '6/22/21 6:00',
    '6/22/21 7:00',
    '6/22/21 8:00',
    '6/22/21 9:00',
    '6/22/21 10:00',
    '6/22/21 11:00',
    '6/22/21 12:00',
    '6/22/21 13:00',
    '6/22/21 14:00',
    '6/22/21 15:00',
    '6/22/21 16:00',
    '6/22/21 17:00',
    '6/22/21 18:00',
    '6/22/21 19:00',
    '6/22/21 20:00',
    '6/22/21 21:00',
    '6/22/21 22:00',
    '6/22/21 23:00',
    '6/23/21 0:00',
    '6/23/21 1:00',
    '6/23/21 2:00',
    '6/23/21 3:00',
    '6/23/21 4:00',
    '6/23/21 5:00',
    '6/23/21 6:00',
    '6/23/21 7:00',
    '6/23/21 8:00',
    '6/23/21 9:00',
    '6/23/21 10:00',
    '6/23/21 11:00',
    '6/23/21 12:00',
    '6/23/21 13:00',
    '6/23/21 14:00',
    '6/23/21 15:00',
    '6/23/21 16:00',
    '6/23/21 17:00',
    '6/23/21 18:00',
    '6/23/21 19:00',
    '6/23/21 20:00',
    '6/23/21 21:00',
    '6/23/21 22:00',
    '6/23/21 23:00',
    '6/24/21 0:00',
    '6/24/21 1:00',
    '6/24/21 2:00',
    '6/24/21 3:00',
    '6/24/21 4:00',
    '6/24/21 5:00',
    '6/24/21 6:00',
    '6/24/21 7:00',
    '6/24/21 8:00',
    '6/24/21 9:00',
    '6/24/21 10:00',
    '6/24/21 11:00',
    '6/24/21 12:00',
    '6/24/21 13:00',
    '6/24/21 14:00',
    '6/24/21 15:00',
    '6/24/21 16:00',
    '6/24/21 17:00',
    '6/24/21 18:00',
    '6/24/21 19:00',
    '6/24/21 20:00',
    '6/24/21 21:00',
    '6/24/21 22:00',
    '6/24/21 23:00',
    '6/25/21 0:00',
    '6/25/21 1:00',
    '6/25/21 2:00',
    '6/25/21 3:00',
    '6/25/21 4:00',
    '6/25/21 5:00',
    '6/25/21 6:00',
    '6/25/21 7:00',
    '6/25/21 8:00',
    '6/25/21 9:00',
    '6/25/21 10:00',
    '6/25/21 11:00',
    '6/25/21 12:00',
    '6/25/21 13:00',
    '6/25/21 14:00',
    '6/25/21 15:00',
    '6/25/21 16:00',
    '6/25/21 17:00',
    '6/25/21 18:00',
    '6/25/21 19:00',
    '6/25/21 20:00',
    '6/25/21 21:00',
    '6/25/21 22:00',
    '6/25/21 23:00',
    '6/26/21 0:00',
    '6/26/21 1:00',
    '6/26/21 2:00',
    '6/26/21 3:00',
    '6/26/21 4:00',
    '6/26/21 5:00',
    '6/26/21 6:00',
    '6/26/21 7:00',
    '6/26/21 8:00',
    '6/26/21 9:00',
    '6/26/21 10:00',
    '6/26/21 11:00',
    '6/26/21 12:00',
    '6/26/21 13:00',
    '6/26/21 14:00',
    '6/26/21 15:00',
    '6/26/21 16:00',
    '6/26/21 17:00',
    '6/26/21 18:00',
    '6/26/21 19:00',
    '6/26/21 20:00',
    '6/26/21 21:00',
    '6/26/21 22:00',
    '6/26/21 23:00',
    '6/27/21 0:00',
    '6/27/21 1:00',
    '6/27/21 2:00',
    '6/27/21 3:00',
    '6/27/21 4:00',
    '6/27/21 5:00',
    '6/27/21 6:00',
    '6/27/21 7:00',
    '6/27/21 8:00',
    '6/27/21 9:00',
    '6/27/21 10:00',
    '6/27/21 11:00',
    '6/27/21 12:00',
    '6/27/21 13:00',
    '6/27/21 14:00',
    '6/27/21 15:00',
    '6/27/21 16:00',
    '6/27/21 17:00',
    '6/27/21 18:00',
    '6/27/21 19:00',
    '6/27/21 20:00',
    '6/27/21 21:00',
    '6/27/21 22:00',
    '6/27/21 23:00',
    '6/28/21 0:00',
    '6/28/21 1:00',
    '6/28/21 2:00',
    '6/28/21 3:00',
    '6/28/21 4:00',
    '6/28/21 5:00',
    '6/28/21 6:00',
    '6/28/21 7:00',
    '6/28/21 8:00',
    '6/28/21 9:00',
    '6/28/21 10:00',
    '6/28/21 11:00',
    '6/28/21 12:00',
    '6/28/21 13:00',
    '6/28/21 14:00',
    '6/28/21 15:00',
    '6/28/21 16:00',
    '6/28/21 17:00',
    '6/28/21 18:00',
    '6/28/21 19:00',
    '6/28/21 20:00',
    '6/28/21 21:00',
    '6/28/21 22:00',
    '6/28/21 23:00',
    '6/29/21 0:00',
    '6/29/21 1:00',
    '6/29/21 2:00',
    '6/29/21 3:00',
    '6/29/21 4:00',
    '6/29/21 5:00',
    '6/29/21 6:00',
    '6/29/21 7:00',
    '6/29/21 8:00',
    '6/29/21 9:00',
    '6/29/21 10:00',
    '6/29/21 11:00',
    '6/29/21 12:00',
    '6/29/21 13:00',
    '6/29/21 14:00',
    '6/29/21 15:00',
    '6/29/21 16:00',
    '6/29/21 17:00',
    '6/29/21 18:00',
    '6/29/21 19:00',
    '6/29/21 20:00',
    '6/29/21 21:00',
    '6/29/21 22:00',
    '6/29/21 23:00',
    '6/30/21 0:00',
    '6/30/21 1:00',
    '6/30/21 2:00',
    '6/30/21 3:00',
    '6/30/21 4:00',
    '6/30/21 5:00',
    '6/30/21 6:00',
    '6/30/21 7:00',
    '6/30/21 8:00',
    '6/30/21 9:00',
    '6/30/21 10:00',
    '6/30/21 11:00',
    '6/30/21 12:00',
    '6/30/21 13:00',
    '6/30/21 14:00',
    '6/30/21 15:00',
    '6/30/21 16:00',
    '6/30/21 17:00',
    '6/30/21 18:00',
    '6/30/21 19:00',
    '6/30/21 20:00',
    '6/30/21 21:00',
    '6/30/21 22:00',
    '6/30/21 23:00',
  ],
  datasets: [
    {
      label: false,
      fill: false,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDash: [],
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointBorderWidth: 1,
      pointHoverRadius: 5,
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: [
        431.162,
        435.078,
        453.684,
        449.026,
        431.844,
        455.250,
        445.003,
        454.295,
        451.748,
        449.675,
        432.524,
        490.283,
        489.239,
        492.065,
        461.429,
        487.334,
        472.218,
        464.565,
        463.658,
        470.398,
        482.848,
        458.140,
        450.651,
        404.192,
        465.251,
        428.392,
        419.704,
        424.966,
        423.719,
        461.978,
        439.810,
        479.230,
        449.801,
        443.972,
        440.772,
        409.102,
        451.612,
        464.151,
        465.808,
        481.169,
        458.307,
        427.431,
        438.858,
        467.816,
        451.834,
        464.336,
        431.788,
        420.072,
        422.992,
        416.958,
        439.872,
        450.469,
        427.368,
        473.634,
        451.617,
        453.682,
        401.036,
        461.667,
        432.139,
        428.424,
        432.914,
        447.097,
        440.061,
        462.030,
        448.845,
        513.310,
        454.858,
        448.832,
        450.577,
        455.703,
        465.969,
        458.276,
        432.003,
        399.218,
        455.045,
        532.198,
        470.002,
        451.163,
        461.095,
        460.417,
        425.813,
        468.224,
        455.793,
        451.518,
        459.330,
        467.459,
        410.616,
        476.156,
        458.662,
        430.559,
        481.697,
        442.794,
        406.736,
        468.984,
        451.837,
        413.136,
        473.751,
        476.037,
        467.231,
        440.198,
        486.347,
        459.089,
        403.893,
        395.053,
        444.697,
        454.264,
        473.795,
        470.828,
        472.370,
        450.651,
        456.972,
        442.809,
        394.858,
        471.624,
        445.433,
        460.428,
        464.399,
        475.617,
        457.997,
        448.739,
        482.840,
        422.568,
        484.628,
        467.058,
        440.766,
        424.335,
        452.367,
        425.072,
        423.009,
        474.785,
        488.706,
        452.877,
        395.939,
        478.014,
        463.633,
        475.302,
        443.858,
        458.771,
        485.485,
        435.096,
        451.827,
        468.800,
        394.262,
        452.009,
        440.604,
        438.636,
        433.603,
        459.760,
        427.709,
        467.861,
        450.646,
        413.986,
        432.439,
        479.787,
        433.846,
        452.900,
        442.993,
        394.840,
        462.788,
        403.497,
        465.747,
        435.818,
        445.675,
        431.401,
        449.781,
        417.745,
        459.573,
        431.980,
        466.012,
        479.382,
        431.722,
        433.314,
        469.975,
        457.921,
        426.102,
        462.098,
        456.505,
        475.741,
        439.001,
        423.908,
        413.070,
        451.126,
        460.065,
        395.674,
        494.444,
        460.405,
        463.232,
        469.800,
        460.975,
        442.116,
        486.676,
        451.586,
        454.572,
        415.908,
        419.065,
        424.229,
        430.007,
        445.794,
        450.104,
        447.058,
        443.420,
        428.793,
        448.165,
        438.904,
        441.016,
        506.224,
        419.037,
        475.560,
        446.258,
        435.978,
        461.816,
        476.760,
        441.132,
        466.810,
        454.646,
        431.339,
        424.440,
        486.804,
        415.596,
        403.898,
        459.754,
        464.321,
        431.004,
        502.204,
        461.519,
        490.200,
        475.707,
        440.489,
        450.658,
        482.960,
        448.886,
        443.951,
        468.778,
        437.759,
        478.970,
        454.213,
        406.805,
        464.746,
        438.201,
        444.219,
        463.288,
        441.448,
        456.870,
        462.213,
        464.248,
        490.177,
        450.373,
        408.443,
        459.930,
        414.506,
        462.083,
        425.601,
        457.732,
        479.042,
        454.480,
        441.662,
        434.353,
        479.825,
        438.238,
        450.292,
        467.624,
        483.765,
        475.744,
        472.802,
        425.508,
        524.541,
        459.239,
        471.029,
        457.240,
        422.589,
        426.310,
        452.614,
        485.384,
        445.737,
        457.327,
        401.973,
        417.999,
        473.361,
        473.034,
        471.509,
        434.988,
        484.066,
        476.757,
        453.356,
        482.136,
        440.263,
        421.237,
        442.743,
        470.136,
        443.064,
        494.745,
        430.841,
        483.923,
        399.256,
        432.226,
        470.817,
        441.261,
        466.506,
        483.567,
        450.970,
        448.853,
        412.929,
        452.535,
        461.677,
        445.480,
        432.943,
        435.515,
        468.274,
        490.758,
        446.298,
        410.917,
        399.975,
        471.985,
        430.804,
        433.890,
        458.287,
        456.259,
        486.053,
        452.322,
        456.585,
        464.231,
        450.258,
        494.599,
        465.237,
        424.509,
        473.212,
        422.853,
        455.157,
        451.855,
        417.825,
        468.607,
        425.032,
        445.952,
        451.815,
        451.607,
        437.379,
        428.652,
        447.516,
        432.401,
        473.013,
        493.840,
        467.076,
        458.414,
        429.639,
        451.268,
        444.703,
        463.885,
        478.831,
        466.676,
        481.931,
        456.547,
        426.004,
        440.609,
        470.730,
        472.428,
        453.899,
        446.982,
        415.101,
        449.752,
        404.382,
        437.651,
        448.168,
        480.340,
        427.130,
        461.077,
        416.161,
        397.978,
        470.618,
        427.084,
        472.073,
        472.702,
        457.563,
        452.925,
        414.613,
        448.214,
        467.265,
        437.645,
        460.745,
        439.571,
        448.913,
        456.828,
        470.333,
        463.508,
        399.110,
        479.277,
        482.924,
        414.554,
        447.885,
        423.018,
        431.432,
        446.679,
        494.639,
        435.297,
        427.569,
        434.944,
        431.632,
        459.988,
        477.439,
        422.583,
        431.216,
        479.517,
        452.635,
        456.346,
        441.053,
        493.276,
        411.288,
        435.699,
        465.288,
        431.316,
        462.521,
        470.835,
        434.402,
        468.871,
        448.388,
        476.585,
        436.335,
        482.245,
        472.927,
        439.270,
        424.280,
        485.466,
        447.402,
        421.539,
        448.417,
        433.819,
        465.857,
        448.518,
        465.880,
        458.575,
        454.652,
        495.666,
        420.183,
        462.295,
        448.667,
        423.918,
        502.748,
        456.087,
        495.852,
        409.419,
        499.241,
        420.328,
        483.514,
        511.885,
        440.984,
        515.709,
        462.880,
        441.769,
        448.580,
        441.515,
        453.234,
        418.835,
        463.694,
        440.547,
        497.609,
        429.626,
        448.137,
        438.655,
        490.657,
        460.272,
        469.657,
        424.098,
        455.431,
        479.291,
        460.935,
        476.697,
        459.524,
        504.860,
        464.226,
        472.223,
        481.035,
        441.052,
        415.258,
        451.875,
        427.426,
        465.330,
        476.899,
        448.241,
        450.142,
        452.906,
        462.470,
        472.773,
        462.978,
        478.824,
        422.995,
        412.703,
        470.478,
        467.054,
        413.327,
        393.426,
        482.586,
        467.823,
        466.339,
        481.281,
        434.255,
        454.091,
        458.150,
        473.087,
        423.992,
        416.206,
        462.515,
        483.546,
        482.966,
        424.703,
        465.003,
        449.903,
        440.598,
        449.949,
        464.045,
        458.301,
        484.353,
        467.462,
        418.678,
        462.652,
        390.936,
        443.878,
        465.731,
        435.309,
        436.825,
        428.095,
        440.547,
        430.709,
        464.816,
        404.387,
        434.191,
        462.892,
        471.334,
        438.333,
        473.270,
        446.471,
        433.624,
        431.938,
        444.842,
        484.071,
        446.811,
        437.080,
        469.762,
        413.461,
        488.240,
        473.943,
        460.920,
        476.392,
        424.632,
        475.925,
        473.787,
        471.498,
        422.285,
        450.735,
        435.458,
        453.204,
        451.339,
        455.618,
        421.172,
        438.920,
        444.023,
        488.383,
        422.045,
        435.380,
        422.093,
        421.279,
        437.064,
        456.820,
        414.403,
        416.391,
        469.832,
        482.892,
        429.922,
        399.213,
        443.850,
        453.800,
        474.453,
        449.517,
        452.317,
        413.477,
        418.498,
        430.022,
        443.534,
        473.756,
        481.853,
        422.304,
        479.435,
        498.366,
        434.651,
        478.149,
        469.362,
        470.477,
        400.065,
        481.393,
        437.671,
        448.867,
        472.656,
        432.547,
        413.448,
        474.413,
        479.448,
        436.186,
        432.715,
        464.660,
        434.787,
        427.399,
        469.520,
        436.432,
        465.529,
        426.769,
        442.773,
        451.261,
        437.518,
        394.003,
        492.165,
        404.363,
        494.824,
        465.793,
        427.177,
        467.330,
        467.406,
        408.466,
        442.141,
        438.407,
        435.937,
        436.984,
        480.959,
        437.325,
        444.919,
        475.752,
        446.436,
        428.880,
        449.481,
        438.926,
        436.032,
        473.110,
        413.086,
        440.286,
        491.658,
        448.967,
        464.255,
        443.646,
        457.156,
        459.980,
        450.017,
        459.144,
        403.440,
        463.516,
        487.260,
        458.837,
        465.968,
        455.969,
        518.134,
        419.502,
        440.396,
        482.789,
        419.140,
        465.384,
        474.833,
        470.357,
        436.770,
        436.220,
        448.674,
        417.319,
        484.329,
        475.015,
        477.512,
        444.263,
        451.969,
        449.074,
        425.647,
        468.190,
        450.764,
        422.026,
        539.944,
        462.478,
        418.815,
        462.780,
        441.020,
        416.982,
        454.312,
        460.124,
        469.456,
        474.032,
        512.497,
        439.886,
        442.747,
        428.988,
        416.516,
        430.924,
        429.639,
        429.632,
        490.779,
        429.368,
        506.480,
        438.699,
        415.709,
        450.419,
        441.701,
        468.319,
        473.273,
        454.151,
        453.324,
        426.662,
        502.766,
        432.191,
        456.660,
        482.071,
        421.657,
        448.964,
        437.539,
        471.740,
        497.166,
        444.867,
        450.740,
        450.651,
        458.103,
        489.782,
        475.981,
        443.616,
        504.956,
        441.098,
        482.922,
        452.580,
        476.336,
        456.833,
        465.477
      ]
    }
  ]
};

export default class SampleLineChart extends React.Component {
  render() {
    return (
      <div>
        <Line
          ref="chart"
          data={data}
          options={{
            title: {
              display: false
            },
            legend: {
              display: false
            }
          }}
        />
      </div>
    );
  }
}
